import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Ccontinue(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>Continue Statement in c tutorial For Beginners</title>
 <meta name="description" content="Continue in c tutorial for beginners.A continue is usually associated with an if,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,continue c,continue in c,continue statement in c,continue c programming,continue in c programming,continue c language,continue cough,continue in c language" />
 <link rel="canonical" href="https://www.codeexampler.com/c-continue" />
 </Helmet>

 <div className='lg:pl-56'>


    <h1 className="m-4 mh1">Continue Statement in C</h1>
    <div className="first">
        <a href="/c-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-array">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
   
<p className="mt-4 para">A continue is usually associated with an if
</p>



<h2 className="headings">The continue C syntax</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-2">continue </span>
            <span className="qwerty-4">;</span>
              {"\n"} 
              {"\n"} 
          </code>
        </pre>
      </div> 


      <h2 className="headings">Q-Write a program loop from 1 to 10 but continue when i=4 in the continue statement in C?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
        <code>
            {"\n"}
            <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">; </span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>                                  
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-6">  if</span>
        <span className="qwerty-4">(</span>
        <span className="qwerty-5">i</span>        
        <span className="qwerty">==</span>
        <span className="qwerty-1">4</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-4">  &#123;</span>
        {"\n"}
        <span className="qwerty-2">   continue</span>
        <span className="qwerty-4">;</span>
        {"\n"}
        <span className="qwerty-8">   printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">this is continue</span>
        <span className="qwerty-4">"</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-4">  &#125;</span>
        {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-10"> \n</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-4">);</span>
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
              {"\n"} 
              {"\n"} 
          </code>        
         </pre>
      </div>     
      <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-1">1</span>                   
                  {"\n"}         
                  <span className="qwerty-1">2</span>
                  {"\n"}         
                  <span className="qwerty-1">3</span>
                  {"\n"}         
                  <span className="qwerty-1">5</span>
                  {"\n"}
                  <span className="qwerty-1">6</span>
                  {"\n"}
                  <span className="qwerty-1">7</span>
                  {"\n"}
                  <span className="qwerty-1">8</span>
                  {"\n"}
                  <span className="qwerty-1">9</span>
                  {"\n"}
                  <span className="qwerty-1">10</span>
                  {"\n"}
                  {"\n"}
                  </code>
                  </pre>
                  </div>      

<p className="mt-4 para">If you don't know about for loop in C so check on <a href="https://www.codeexampler.com/c-for-loop">C for loop tutorial</a>.</p>

<h2 className="headings">Q-Write a program loop that starts from 1 to 10 but continue when i=4 or 8 in the continue statement in C?</h2>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
          <code>
              {"\n"}
              <span className="qwerty-7">#include </span>
           <span className="qwerty-4">&#60;</span>
           <span className="qwerty-10">stdio.h</span>
           <span className="qwerty-4">&#62; </span>
                          {"\n"} 
          <span className="qwerty-3">int </span>
          <span className="qwerty-2">main</span>
          <span className="qwerty-4"> ()</span>            
          {"\n"}
          <span className="qwerty-4" >&#123; </span>            
          {"\n"}
          <span className="qwerty-3"> int</span>
          <span className="qwerty-5"> i</span>                     
          <span className="qwerty-4">;</span>                     
          {"\n"}
          <span className="qwerty-6"> for</span>
          <span className="qwerty-4"> (</span>
          <span className="qwerty-5">i</span>
          <span className="qwerty-4">=</span>
          <span className="qwerty-1">1</span>
          <span className="qwerty-4">; </span>
          <span className="qwerty-5">i</span>
          <span className="qwerty">&#60;=</span>
          <span className="qwerty-1">10</span>
          <span className="qwerty-4">;</span>
          <span className="qwerty-5">i</span>
          <span className="qwerty">++</span>                                  
        <span className="qwerty-4">)</span>
          {"\n"} 
          <span className="qwerty-4"> &#123;</span>
          {"\n"}
          <span className="qwerty-6">  if</span>
          <span className="qwerty-4">(</span>
          <span className="qwerty-5">i</span>        
          <span className="qwerty">==</span>
          <span className="qwerty-1">4</span>
          <span className="qwerty-3"> || </span>
          <span className="qwerty-5">i</span>        
          <span className="qwerty">==</span>
          <span className="qwerty-1">8</span>
          <span className="qwerty-4">);</span>
          {"\n"}
          <span className="qwerty-4">  &#123;</span>
          {"\n"}
          <span className="qwerty-2">   continue</span>
          <span className="qwerty-4">;</span>
          {"\n"}
          <span className="qwerty-8">   printf</span>
          <span className="qwerty-4">("</span>
          <span className="qwerty-10">count</span>
          <span className="qwerty-4">"</span>
          <span className="qwerty-4">);</span>
          {"\n"}
          <span className="qwerty-4">  &#125;</span>
          {"\n"}
          <span className="qwerty-8">  printf</span>
          <span className="qwerty-4">("</span>
          <span className="qwerty-3">%d</span>
          <span className="qwerty-10"> \n</span>
          <span className="qwerty-4">",</span>
          <span className="qwerty-4">);</span>
          {"\n"}
                <span className="qwerty-4"> &#125;</span>
          {"\n"}
          <span className="qwerty-7"> return</span>
          <span className="qwerty-3"> 0</span>
          <span className="qwerty-4">; </span>
              {"\n"}
          <span className="qwerty-4">&#125;</span>
                {"\n"} 
                {"\n"} 
            </code>        
           </pre>
        </div>     
        <h4 className='headings'>Output :</h4>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
            <pre style={{maxHeight:"100vh"}}>
                  <code >                  
                  {"\n"}      
                    <span className="qwerty-1">1</span>                   
                    {"\n"}         
                    <span className="qwerty-1">2</span>
                    {"\n"}         
                    <span className="qwerty-1">3</span>
                    {"\n"}         
                    <span className="qwerty-1">5</span>
                    {"\n"}
                    <span className="qwerty-1">6</span>
                    {"\n"}
                    <span className="qwerty-1">7</span>
                    {"\n"}
                    <span className="qwerty-1">9</span>
                    {"\n"}
                    <span className="qwerty-1">10</span>
                    {"\n"}
                    {"\n"}
                    </code>
                    </pre>
                    </div> 

                    <h2 className="headings">Q-Write a program loop from 1 to 10 but continue when even no occur in the continue statement in C?</h2>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
          <code>
              {"\n"}
              <span className="qwerty-7">#include </span>
           <span className="qwerty-4">&#60;</span>
           <span className="qwerty-10">stdio.h</span>
           <span className="qwerty-4">&#62; </span>
                          {"\n"} 
          <span className="qwerty-3">int </span>
          <span className="qwerty-2">main</span>
          <span className="qwerty-4"> ()</span>            
          {"\n"}
          <span className="qwerty-4" >&#123; </span>            
          {"\n"}
          <span className="qwerty-3"> int</span>
          <span className="qwerty-5"> i</span>                     
          <span className="qwerty-4">;</span>                     
          {"\n"}
          <span className="qwerty-6"> for</span>
          <span className="qwerty-4"> (</span>
          <span className="qwerty-5">i</span>
          <span className="qwerty-4">=</span>
          <span className="qwerty-1">1</span>
          <span className="qwerty-4">;</span>
          <span className="qwerty-5">i</span>
          <span className="qwerty">&#60;=</span>
          <span className="qwerty-1">8</span>
          <span className="qwerty-4">;</span>
          <span className="qwerty-5">i</span>
          <span className="qwerty">++</span>                                  
        <span className="qwerty-4">)</span>
          {"\n"} 
          <span className="qwerty-4"> &#123;</span>
          {"\n"}
          <span className="qwerty-6">  if</span>
          <span className="qwerty-4">(</span>
          <span className="qwerty-5">i</span>        
          <span className="qwerty">%</span>
          <span className="qwerty-1">2</span>
          <span className="qwerty">==</span>
          <span className="qwerty-1">0</span>
          <span className="qwerty-4">);</span>
          {"\n"}
          <span className="qwerty-4">  &#123;</span>
          {"\n"}          
          <span className="qwerty-8">  printf</span>
          <span className="qwerty-4">("</span>
          <span className="qwerty-3">%d</span>
          <span className="qwerty-10"> \n</span>
          <span className="qwerty-4">",</span>
          <span className="qwerty-4">);</span>
          {"\n"}
          <span className="qwerty-4">  &#125;</span>
          {"\n"}
          <span className="qwerty-6">  else</span>
          {"\n"}
          <span className="qwerty-2">   continue</span>
          <span className="qwerty-4">;</span>
          {"\n"}
                <span className="qwerty-4"> &#125;</span>
          {"\n"}
          <span className="qwerty-7"> return</span>
          <span className="qwerty-3"> 0</span>
          <span className="qwerty-4">; </span>
              {"\n"}
          <span className="qwerty-4">&#125;</span>
                {"\n"} 
                {"\n"} 
            </code>        
           </pre>
        </div>     
        <h4 className='headings'>Output :</h4>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
            <pre style={{maxHeight:"100vh"}}>
                  <code >                  
                  {"\n"}      
                    <span className="qwerty-1">2</span>
                    {"\n"}         
                    <span className="qwerty-1">4</span>
                    {"\n"}
                    <span className="qwerty-1">6</span>
                    {"\n"}
                    <span className="qwerty-1">8</span>
                    {"\n"}
                    {"\n"}
                    </code>
                    </pre>
                    </div>  

<h1 className="mt-5">  </h1>

<div className="back">
        <a href="/c-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-array">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Ccontinue;